import React from 'react'

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-16 bg-gray-50 text-center">
      <div className="container-padding">
        <h2 className="text-3xl font-semibold mb-8">How FlowBeatIQ Works</h2>
        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div>
            <img src="/icons/plug.svg" className="mx-auto mb-4 w-16 h-16" alt="Plug In"/>
            <h3 className="font-bold mb-2 text-xl">1. Plug In</h3>
            <p className="text-gray-600">Connect the FlowBeatIQ sensor to any standard outlet.</p>
          </div>
          <div>
            <img src="/icons/wifi.svg" className="mx-auto mb-4 w-16 h-16" alt="Connect"/>
            <h3 className="font-bold mb-2 text-xl">2. Connect</h3>
            <p className="text-gray-600">Pair it once to Wi-Fi using your phone or laptop.</p>
          </div>
          <div>
            <img src="/icons/chart.svg" className="mx-auto mb-4 w-16 h-16" alt="See Insights"/>
            <h3 className="font-bold mb-2 text-xl">3. See Insights</h3>
            <p className="text-gray-600">Your dashboard updates in real time — no cameras or manual counts.</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HowItWorksSection
